'use strict';

goog.provide('Ntry.InterfaceManager');

goog.require('Ntry.ConfigManager');

Ntry.InterfaceManager = function() {
    var view = document.getElementById('ntry');
    this._view = view;
    this.createDom();
};

(function(p) {
    p.updateConfig = function() {
        $(this.getDom('ntryWeek')).addClass(this.getTheme());
    };

    p.createDom = function() {
        var leftCol = Ntry.createElement('div', this._view, null, 'ntryLeftCol');
        var canvasContainer = Ntry.createElement(
            'div',
            leftCol,
            'ntryCanvasContainer',
            'ntryCanvasContainer'
        );
        Ntry.createElement('canvas', canvasContainer, 'canvas');
        Ntry.createElement('div', leftCol, 'ntryEngine', 'ntryEngine');
        Ntry.createElement('div', leftCol, 'ntryHintArea', 'ntryHintArea');
        var rightCol = Ntry.createElement('div', this._view, 'ntryPlayground', 'ntryRightCol');

        Ntry.createElement('div', this._view, 'ntryIntroArea', 'ntryIntroArea');
        Ntry.createElement('div', this._view, 'ntryResultArea', 'ntryResultArea');
    };

    p.removeDom = function() {
        $(this._view).empty();
    };

    p.getDom = function(id) {
        return document.getElementById(id);
    };

    p.getTheme = function() {
        var cm = Ntry.configManager;
        var theme = cm.getConfig('theme');
        if (theme) return theme;
        else {
            var num = cm.getConfig('stageId');
            if (num > 20) return 'mazeVer4';
            else if (num > 14 && num <= 20) return 'mazeVer3';
            else if (num > 6 && num < 15) return 'mazeVer2';
            else return 'mazeVer1';
        }
    };
})(Ntry.InterfaceManager.prototype);
